import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Box,
    TextField,
    Typography,
    Button,
    Avatar,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    InputAdornment,
    MenuItem,
    Select
} from "@mui/material";

const Search = ({ open, onClose }) => {
    const [module, setModule] = useState("all");
    const [searchValue, setSearchValue] = useState("");
    const navigate = useNavigate();

    const previousPath = window.location.pathname.toLowerCase();

    const handleSearch = () => {
        const queryParams = new URLSearchParams({
            module,
            searchValue
        });
        navigate(`/globalsearch?${queryParams.toString()}`);

        if (previousPath.includes('/globalsearch')) {
            window.location.reload();
        }
        
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>Search</DialogTitle>
            <DialogContent>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #d1d5db",
                        borderRadius: "12px",
                        overflow: "hidden",
                        width: "100%",
                        maxWidth: 600,

                    }}
                >
                    {/* Dropdown */}
                    <Select
                        value={module}
                        variant="standard"
                        disableUnderline
                        sx={{
                            background: "white",
                            paddingX: 1.5,
                            height: "40px",
                            fontSize: "14px",
                            color: "#333",
                        }}
                        onChange={(e) => setModule(e.target.value)}
                    >
                        <MenuItem value="notes">Notes</MenuItem>
                        <MenuItem value="leads">Leads</MenuItem>
                        <MenuItem value="contacts">Contacts</MenuItem>
                        <MenuItem value="accounts">Accounts</MenuItem>
                        <MenuItem value="campaigns">Campaigns</MenuItem>
                        <MenuItem value="deals">Deals</MenuItem>
                        <MenuItem value="tasks">Tasks</MenuItem>
                        <MenuItem value="all">All Modules</MenuItem>

                    </Select>

                    {/* Search Input */}
                    <TextField
                        variant="standard"
                        placeholder="Search..."
                        fullWidth
                        onChange={(e) => setSearchValue(e.target.value)}
                        InputProps={{
                            disableUnderline: true,
                            sx: {
                                paddingLeft: 2,
                                fontSize: "14px",
                                color: "#999",
                            },

                        }}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSearch}
                >
                    Search
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default Search;